import { ActionCreatorProps, createAction, createActionGroup, Creator, emptyProps, props } from "@ngrx/store";
import { Vector2, Vector3 } from "three";
import { createInstanceActionGroup } from "../../../instance-service/state-utils/instanceActionGroup";

export const postActions = (entityId: string) => {
  return createInstanceActionGroup({
    source: `Post`,
    instanceId: entityId,
    events: {
      "Move": props<{ target: Vector3 }>(),
      "Rewind Target": emptyProps(),
    }
  })
}

// type postActions = ReturnType<typeof postActions>

// const instanceTest = createInstanceActionGroup({
//   source: 'post',
//   instanceId: '123',
//   events: {
//     "Move": props<{ target: Vector3 }>(),
//     "Rewind Target": emptyProps(),
//   }
// })
//
//
